<template>
    <span ref="span" v-html="$t('iap.more-information', {termsLink: termsLink, privacyLink: privacyLink})"></span>
</template>
<script>
export default {
    created() {
        this.termsLink = '<a href="#/terms-and-conditions" class="support-btn"><u>' + this.$t('support.terms_of_service') + '</u></a>';
        this.privacyLink = '<a href="#/privacy-policy" class="support-btn"><u>' + this.$t('support.privacy_protection') + '</u></a>';
    },
    mounted() {
        const links = this.$refs['span'].getElementsByTagName('A');
        for (let el of links) {
            el.addEventListener('click', this.onClick);
        }
    },
    beforeDestroy() {
        const links = this.$refs['span'].getElementsByTagName('A');
        for (let el of links) {
            el.removeEventListener('click', this.onClick);
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>
